import Slider from '../Elements/Slider';

/**
 * GallerySlider
 */
const GallerySlider = (() => {
	/**
	 * Gallery
	 *
	 * @var { Object }
	 */
	const Selector = {
		GALLERY_SLIDER: '.gallery-slider > .owl-carousel',
	};

	/**
	 * GallerySlider
	 *
	 * @class
	 * @augments Slider
	 */
	class GallerySlider extends Slider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this.initialize({
				margin: 30,
				responsive: {
					0: {
						margin: 15
					},
					640: {
						margin: 30
					}
				}
			});
		}
	}

	return GallerySlider._getElements(Selector.GALLERY_SLIDER, GallerySlider);
})();

export default GallerySlider;
